// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ot-9";
export var arrowButtonContainer = "_ot-5";
export var arrowButtonIcon = "_ot-6";
export var carouselArrowButton = "_ot-2";
export var carouselElementContainer = "_ot-1";
export var currentSlide = "_ot-8";
export var left = "_ot-3";
export var otherSlide = "_ot-a";
export var productCarouselContainer = "_ot-0";
export var right = "_ot-4";
export var sliderOverflow = "_ot-7";